import getCurrentLocationUrl from 'common/src/modules/routing/utils/getCurrentLocationUrl';
import {Chat, ChatState} from '../../../copilot.types';
import {snapshotSchemaVersion} from '../../persistence.consts';
import {PersistedChatSnapshot} from '../../persistence.types';

export default function convertChatToSnapshot(
  reduxChat: ChatState,
  chat: Chat,
): PersistedChatSnapshot {
  const session = chat.agentSession;

  // TODO: once skills mode is GA, session will always be present and we can delete this check.
  if (!session) {
    throw new Error('convertChatToSnapshot is only supported when an agent session is active');
  }

  return {
    version: snapshotSchemaVersion,
    createdAt: new Date().toISOString(),
    chatId: reduxChat.id,
    chatType: chat.type,
    userLocationUrlAtExport: getCurrentLocationUrl(),
    redux: {
      type: reduxChat.type,
      title: reduxChat.title,
      isPlanModeEnabled: reduxChat.isPlanModeEnabled,
      chatItems: reduxChat.chatItems.filter((item) => !item.isExcludedOnExport),
      modalWidget: reduxChat.modalWidget,
      blockingChatItemId: reduxChat.blockingChatItemId,
      informationText: reduxChat.informationText,
      draftMessage: reduxChat.draftMessage,
      status: reduxChat.status,
      lastUpdated: new Date().toISOString(),
      plan: reduxChat.plan
        ? {
            id: reduxChat.plan.id,
            createdAt: reduxChat.plan.createdAt.toISO(),
            ownerAgentName: reduxChat.plan.ownerAgentName,
            goal: reduxChat.plan.goal,
            steps: reduxChat.plan.steps,
            status: reduxChat.plan.status,
            skillNames: reduxChat.plan.skillNames,
            resources: reduxChat.plan.resources,
            issues: reduxChat.plan.issues,
            openQuestions: reduxChat.plan.openQuestions,
            userInteractionStatus: reduxChat.plan.userInteractionStatus,
          }
        : null,
      isPlanModeToggleOn: reduxChat.isPlanModeToggleOn,
      planCollapseState: reduxChat.planCollapseState,
      contextWindowUsage: reduxChat.contextWindowUsage,
    },
    runtime: {
      agentSession: {
        sessionId: session.sessionId,
        memory: session.memory,
        summary: session.summary,
        createdAtTimestamp: session.createdAtTimestamp,
      },
      blackboard: {
        chatHistory: chat.blackboard.chatHistory.map((entry) => ({
          sessionStartedAt: entry.sessionStartedAt.toISOString(),
          sessionEndedAt: entry.sessionEndedAt.toISOString(),
          sessionId: entry.sessionId,
          agentName: entry.agentName,
          facts: entry.facts,
        })),
        plan: chat.blackboard.plan
          ? {
              id: chat.blackboard.plan.id,
              createdAt: chat.blackboard.plan.createdAt.toISO() ?? '',
              ownerAgentName: chat.blackboard.plan.ownerAgentName,
              goal: chat.blackboard.plan.goal,
              steps: chat.blackboard.plan.steps,
              skillNames: chat.blackboard.plan.skillNames,
              resources: chat.blackboard.plan.resources,
              issues: chat.blackboard.plan.issues,
              openQuestions: chat.blackboard.plan.openQuestions,
              userInteractionStatus: chat.blackboard.plan.userInteractionStatus,
            }
          : null,
      },
      files: chat.files,
    },
  } satisfies PersistedChatSnapshot;
}
